import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/queues',
    id : null,
    name : "",
    ticket_number_min : "",
    ticket_number_max : "",
    active_times_open : "",
    active_times_close : "",
    agents : "",
    queue_macro: "",
    min_service_time: 0,
    notification_time_after_service: 5
});

